import types from '../loadsSearch/types';
import {recentSearches} from '../recentSearches/actions';

export default {
  [types.LOADS_CRITERIA_COMPLETED]: [
    (action, store) => {
      if (action.pending || action.error) {
        return null;
      }
      return recentSearches(store.getState().loadsSearch.queryCompleted);
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/recentSearches/reactions.js